import React from 'react';
import { observer } from 'mobx-react-lite';
import AddToWishListButton from '../components/AddToWishListButton/AddToWishListButton';
import ErrorMessage from '../components/Errors/ErrorMessage/ErrorMessage';
import WishListList from '../components/WishListList/WishListList';
import styles from '../App.module.scss';
import { ViewWishListButton } from '../components/ViewMyWishListButton/ViewMyWishListButton';

interface ContainerProps {
    handleWishListOnClick: (wishListId: string) => Promise<void> | never;
    productExistsInWishLists?: boolean;
    shouldWishListsBeExpanded: boolean;
    hasError: boolean;
    hasMoreThanOneWishlist: boolean;
    wishLists?: ProductWishList[];
    errorMessage: string;
    isCallingAPI: boolean;
    productId: string;
}

const fireNewRelicEventForMyJLLink = (): void => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (typeof window.newrelic.addPageAction !== 'undefined') {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.newrelic.addPageAction('wishlist-join-myjl-link-click');
    }
};

const Container: React.FC<ContainerProps> = observer(
    ({
        handleWishListOnClick,
        productExistsInWishLists,
        shouldWishListsBeExpanded = false,
        wishLists,
        isCallingAPI = false,
        hasError = false,
        errorMessage = '',
        hasMoreThanOneWishlist = false,
        productId,
    }) => {
        return (
            <>
                <AddToWishListButton
                    handleWishListOnClick={handleWishListOnClick}
                    isAdded={productExistsInWishLists}
                    isExpanded={shouldWishListsBeExpanded}
                    isSubmitting={isCallingAPI}
                    productId={productId}
                />
                <ErrorMessage hasError={hasError} message={errorMessage} />
                <WishListList
                    wishLists={wishLists}
                    handleWishListOnClick={handleWishListOnClick}
                    isExpanded={shouldWishListsBeExpanded}
                    isSubmitting={isCallingAPI}
                    productId={productId}
                />
                {shouldWishListsBeExpanded && (
                    <div className={styles.viewMyWishListButtonContainer}>
                        <div className={styles.wishlistMyjl}>
                            <div>Want the chance to win your wish list each month?</div>
                            <a
                                className="wishlist-join-myjl-link"
                                onClick={fireNewRelicEventForMyJLLink}
                                href="https://account.johnlewis.com/rewards#intcmp=ic_20221013_winyourwishlistpdptest_pp_gif_b_insb_"
                            >
                                {' '}
                                Enter with My John Lewis{' '}
                            </a>
                        </div>
                        <ViewWishListButton hasMoreThanOneList={hasMoreThanOneWishlist} />
                    </div>
                )}
            </>
        );
    },
);

export default Container;
